import * as angular from 'angular';

export default class Validation {
  getValidationClass(field) {
    if (field.$dirty && field.$invalid) {
      return 'show-validation-feedback ng-invalid';
    }

    if (field.$valid) {
      return 'show-validation-feedback ng-valid';
    }
  }

  validateAllFields(form) {
    angular.forEach(form.$error.required, function (field) {
      field.$pristine = false;
      field.$dirty = true;
    });
  }
}
